import React from "react";
import { Dialog } from "@mui/material";

import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as QuestionMarkIcon } from "assets/img/svg/QuestionMarkConfirmationDialog.svg";

import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";

const EditDeleteConfirmationDialog = ({
  onClose,
  type = "edit",
  open,
  data,
  editStatus,
  deleteMapping,
}) => {
  return (
    <Dialog
      aria-label="Confirm Update/Delete Action"
      open={open}
      fullWidth
      size="sm"
    >
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-between">
          {type === "edit" ? (
            <h2 className="mb-0 text-bold mb-3">Update Status</h2>
          ) : (
            <QuestionMarkIcon />
          )}
          <CrossIcon onClick={onClose} />
        </div>

        <section>
          <p>
            Are you sure you want to
            {type === "edit"
              ? ` mark this mapping ${data.updatedStatus} ?`
              : " delete this mapping ?"}
          </p>

          <div className="mt-4">
            <button className="no-ml-btn" onClick={onClose}>
              Cancel
            </button>

            {type === "edit" ? (
              <AButton variant="primary_filled" onClick={editStatus}>
                Confirm
              </AButton>
            ) : (
              <AButton variant="danger_filled" onClick={deleteMapping}>
                Delete
              </AButton>
            )}
          </div>
        </section>
      </div>
    </Dialog>
  );
};

export default EditDeleteConfirmationDialog;
